import { AppBadgeForAno } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useAnoMenuItems } from '@/hooks/useAnoMenuItems'

type AnoMenuCellProps = {
  ano: string | null
  salesforceProjectId?: number | null
  pksId?: number | null
}

export function AnoMenuCell({ ano, salesforceProjectId, pksId }: AnoMenuCellProps) {
  const menuUrls = useAnoMenuItems({ ano, salesforceProjectId, pksId })
  return <AppBadgeForAno ano={ano} menuUrls={menuUrls} />
}
